import { Col, Descriptions, Row } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CollapseArrayView from "../../../../components/CollapseArrayView/CollapseArrayView";
import { CompanyDetails } from "../../../../modules/settings/settings.types";
import style from "./CompanyDetails.module.scss";

interface CompanyDetailsSectionProps {
  companyDetails: CompanyDetails | undefined;
}

const CompanyDetailsSection = ({
  companyDetails,
}: CompanyDetailsSectionProps) => {
  const { t } = useTranslation();

  const descriptionItems = useMemo(
    () =>
      [
        {
          key: "name",
          label: t("SETTINGS_COMPANY.NAZIV"),
          children: <span>{companyDetails?.naziv}</span>,
        },
        {
          key: "userType",
          label: t("SETTINGS_COMPANY.TIP_KORISNIKA"),
          children: <span>{companyDetails?.tipSubjekta}</span>,
        },
        {
          key: "email",
          label: t("SETTINGS_COMPANY.E_POSTA"),
          children: (
            <Col>
              {companyDetails?.emailAdresa?.slice(0, 3).map((email, index) => (
                <Row key={index}>{email}</Row>
              ))}
              {companyDetails?.emailAdresa?.slice(3).length ? (
                <CollapseArrayView
                  elementKey="emailAdresa"
                  items={companyDetails?.emailAdresa}
                />
              ) : null}
            </Col>
          ),
        },
        {
          key: "jbkjs",
          label: t("SETTINGS_COMPANY.JBKJS"),
          children: <span>{companyDetails?.jbkjs}</span>,
        },
        {
          key: "pib",
          label: t("SETTINGS_COMPANY.PIB"),
          children: <span>{companyDetails?.pib}</span>,
        },
        {
          key: "street",
          label: t("SETTINGS_COMPANY.ULICA_BROJ"),
          children: <span>{companyDetails?.adresa}</span>,
        },
        {
          key: "city",
          label: t("SETTINGS_COMPANY.GRAD"),
          children: <span>{companyDetails?.imeGrada}</span>,
        },
        {
          key: "postalCode",
          label: t("SETTINGS_COMPANY.POSTANSKI_BROJ"),
          children: <span>{companyDetails?.postanskiBroj}</span>,
        },
        {
          key: "country",
          label: t("SETTINGS_COMPANY.DRZAVA"),
          children: <span>{companyDetails?.imeDrzave}</span>,
        },
        {
          key: "accountNumber",
          label: t("SETTINGS_COMPANY.BROJ_TEKUCEG_RACUNA"),
          children: (
            <Col>
              {companyDetails?.brojTekucegRacuna
                ?.slice(0, 3)
                .map((racun, index) => (
                  <Row key={index}>{racun}</Row>
                ))}
              {companyDetails?.brojTekucegRacuna?.slice(3).length ? (
                <CollapseArrayView
                  elementKey="brojTekucegRacuna"
                  items={companyDetails?.brojTekucegRacuna}
                />
              ) : null}
            </Col>
          ),
        },
      ] as DescriptionsItemType[],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [companyDetails]
  );

  return (
    <Descriptions
      column={1}
      title={t("SETTINGS_COMPANY.DETALJI_KOMPANIJE")}
      className={style.descriptionsWrapper}
      labelStyle={{ width: "60%" }}
      items={descriptionItems}
      colon={false}
    />
  );
};

export default CompanyDetailsSection;
